import { getEpgMenu, getEpgVersion } from 'containers/User/service';
import {
  FETCH_EPG_MENU_ERROR,
  FETCH_EPG_MENU_INIT,
  FETCH_EPG_MENU_SUCCESS,
} from 'actions/epgMenu';
import { fetchEpgLineUp } from 'action-creators/epgLineUp';
import {
  FETCH_EPG_VERSION_ERROR,
  FETCH_EPG_VERSION_INIT,
  FETCH_EPG_VERSION_SUCCESS,
} from '../actions/epgVersion';
import { fetchEpgMenu } from './epgMenu';

export const fetchEpgVersion = (params = {}, cb) => async dispatch => {
  try {
    dispatch({ type: FETCH_EPG_VERSION_INIT });
    dispatch({ type: FETCH_EPG_MENU_INIT });
    const [epgVersionResponse, epgMenuResponse] = await Promise.all([
      getEpgVersion(params),
      getEpgMenu(params),
    ]);
    const { response: epgVersion } = epgVersionResponse;
    const { response: epgMenu } = epgMenuResponse;
    dispatch({
      type: FETCH_EPG_MENU_SUCCESS,
      payload: { ...epgMenu },
    });
    dispatch({
      type: FETCH_EPG_VERSION_SUCCESS,
      payload: epgVersion.epg_version,
    });
    localStorage.setItem('epgVersion', epgVersion.epg_version);
    localStorage.setItem('epgMenu', JSON.stringify(epgMenu));
    cb();
  } catch (e) {
    dispatch({ type: FETCH_EPG_VERSION_ERROR, error: e });
    dispatch({ type: FETCH_EPG_MENU_ERROR, error: e });
  }
};
